// import 'babel-polyfill'
import 'core-js/stable'
import 'regenerator-runtime/runtime'
import Vue from 'vue'
import 'normalize.css/normalize.css' // a modern alternative to CSS resets

import { isPermission, isPagePermission } from './permission'
import ElementUI from 'element-ui'
// import VueViewer from 'v-viewer'
import './styles/element-variables.scss'

import '@/styles/index.scss' // global css
import 'viewerjs/dist/viewer.css'

import App from './App'
import store from './store'
import router from './router'
import '@/components/index'
import '@/styles/base.scss'
// 回显工具函数
import func from '@/views/approvalCenter/plugin/preload.js'
import './icons' // icon
import './permission' // permission control
import './utils/error-log' // error log
import '@/utils/preventReClick'

import * as filters from './filters' // global filters

import { getThemeCluster } from '@/utils/colorPicker.js'

import UploadMixin from '@/mixins/upload'

// import Print from '@/plugins/print'

/**
 * If you don't want to use mock-server
 * you want to use MockJs for mock api
 * you can execute: mockXHR()
 *
 * Currently MockJs will be used in the production environment,
 * please remove it before going online ! ! !
 */
// if (process.env.NODE_ENV === 'production') {
//   const { mockXHR } = require('../mock')
//   mockXHR()
// }
// register global utility filters
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})
// 公共上传传参
const uploadData = {
  source: 'bpm'
}
Vue.prototype.$uploadData = uploadData
// 审批节点设置的全局工具函数
Vue.prototype.$isPermission = isPermission
Vue.prototype.$isPagePermission = isPagePermission
Vue.prototype.$func = func
Vue.config.productionTip = false
Vue.use(ElementUI)
import fileViewer from './fileViewer'
Vue.prototype.$fileView = fileViewer
Vue.mixin(UploadMixin)
// Vue.use(VueViewer, {
//   defaultOptions: {
//     zIndex: 6666 // 这里设置层级高度
//   }
// }) // 图片预览插件
// Vue.use(Print) // 注册打印

new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})

// 初始化主题色
const theme = '#2C51EF'
const themeRefresh = getThemeCluster(theme.replace('#', ''))
store.dispatch('theme/setThemeColor', themeRefresh)
